import { crudMdActions } from "@/services/crud-md-actions";

const name = "trainers";

export default {
  name,
  ...crudMdActions(name),
};
